module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("Looking for "), _c('b', [_vm._v("The Stranger")])]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("Albert Camus and the Life of a Literary Classic")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("ALICE KAPLAN")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("The University of Chicago Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Chicago and London")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cfa58e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Kaplan-Stranger-US-pbk-0003.vue
// module id = 60
// module chunks = 0